function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { DatePicker, Space, Table, message, Button, Divider, Form, Select } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { Excel } from "antd-table-saveas-excel";
import { Col as AntCol, Row as AntRow } from "antd";
import moment from "moment";
import { Download, Cash, BuildingFill, BuildingFillGear } from "react-bootstrap-icons";
import Common from "./includes/Common";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;

var CompanyBills = function CompanyBills() {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      listOfBills = _useState2[0],
      setListOfBills = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      billsArrayData = _useState4[0],
      setBillsArrayData = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isDataLoading = _useState6[0],
      setIsDataLoading = _useState6[1];

  var _useState7 = useState(moment().startOf('month').format()),
      _useState8 = _slicedToArray(_useState7, 2),
      from = _useState8[0],
      setFrom = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedCompanyId = _useState10[0],
      setSelectedCompanyId = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      companyList = _useState12[0],
      setCompanyList = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      company = _useState14[0],
      setCompany = _useState14[1];

  var _useState15 = useState(moment().endOf('month').format()),
      _useState16 = _slicedToArray(_useState15, 2),
      to = _useState16[0],
      setTo = _useState16[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      dataChanged = _useState18[0],
      setDataChanged = _useState18[1];

  var handleExport = function handleExport() {
    var excel = new Excel();
    excel.addSheet("sheet").addColumns(cols).addDataSource(billsArrayData, {
      str2Percent: true
    }).saveAs(from + "-" + to + ".xlsx");
  };

  var sharedOnCell = function sharedOnCell(_, index) {
    if (index < listOfBills.length) {
      return {
        colSpan: 0
      };
    }

    return {};
  };

  var rangePresets = {
    "Aujourdh'ui": [moment().startOf('day'), moment().endOf('day')],
    'Cette semaine': [moment().startOf('week'), moment().endOf('week')],
    'Ce mois': [moment().startOf('month'), moment().endOf('month')]
  };
  var cols = [{
    title: "Date prestation",
    dataIndex: "date",
    render: function render(date, row, index) {
      if (index > billsArrayData.length) {
        return /*#__PURE__*/_jsxs("b", {
          children: [date, " "]
        });
      }

      return {
        children: /*#__PURE__*/_jsx("b", {
          children: date
        }),
        props: {
          colSpan: 6
        }
      };
    },
    onCell: function onCell(_, index) {
      return {
        colSpan: index > billsArrayData.length ? 6 : 1
      };
    },
    key: "date"
  }, {
    title: "Assuré principal",
    dataIndex: "patient",
    render: function render(text) {
      if (text != null) return /*#__PURE__*/_jsx("b", {
        children: text
      });else return {
        props: {
          colSpan: 0
        }
      };
    },
    onCell: sharedOnCell,
    key: "patient"
  }, {
    title: "Bénéficiaire",
    dataIndex: "beneficiary",
    render: function render(text) {
      if (text != null) return /*#__PURE__*/_jsx("b", {
        children: text
      });else return {
        props: {
          colSpan: 0
        }
      };
    },
    onCell: sharedOnCell,
    key: "beneficiary"
  }, {
    title: "Acte (s)",
    dataIndex: "acte",
    render: function render(text) {
      if (text != null) return /*#__PURE__*/_jsx("b", {
        children: text
      });else return {
        props: {
          colSpan: 0
        }
      };
    },
    onCell: sharedOnCell,
    key: "acte"
  }, {
    title: "Total (GNF)",
    dataIndex: "total",
    render: function render(text) {
      if (text != null) return /*#__PURE__*/_jsx("b", {
        children: text
      });else return {
        props: {
          colSpan: 0
        }
      };
    },
    onCell: sharedOnCell,
    key: "total"
  }, {
    title: "Part assuré",
    dataIndex: "patient_part",
    render: function render(text) {
      if (text != null) return /*#__PURE__*/_jsx("b", {
        children: text
      });else return {
        props: {
          colSpan: 0
        }
      };
    },
    onCell: sharedOnCell,
    key: "patient_part"
  }, {
    title: "Part Entreprise",
    dataIndex: "company_part",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "company_part"
  }];

  var fetchBillsData = function fetchBillsData(fr, t, cid) {
    setDataChanged(true);
    axios.get(Common.baseApiUrl + "getcompanybills/" + fr + "/" + t + "/" + cid + "/" + Common.currentUser.id).then(function (response) {
      setListOfBills([]);
      setBillsArrayData([]);

      if (response.data.status == 200) {
        setListOfBills(response.data.billsdata);
        setCompany(response.data.company);
        var totalDue = 0;
        response.data.billsdata.forEach(function (b) {
          var iar = [];
          b.bill_items.forEach(function (i) {
            if (i.medical_item != null) iar.push(i.medical_item.label);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: b.id,
              date: new Date(b.created_at).toLocaleDateString("Fr"),
              patient: b.customer.firstname + " " + b.customer.lastname,
              beneficiary: b.customer.insnumber,
              acte: iar.join(", "),
              total: b.total_amount.toLocaleString("Fr"),
              patient_part: b.patient_part.toLocaleString("Fr"),
              company_part: b.company_part != null ? b.company_part.toLocaleString("Fr") : 0
            }]);
          });
          totalDue += b.company_part;
        });

        if (response.data.company != null) {
          var com_amount = totalDue * response.data.company.commercial_rate * 0.01;
          var tbp_amount = totalDue - com_amount;
          var tax_amount = tbp_amount * response.data.company.tax_rate * 0.01;
          var final_amount = tbp_amount - tax_amount;
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "t1",
              date: "TOTAL (GNF)",
              company_part: totalDue.toLocaleString("Fr"),
              patient: null,
              beneficiary: null,
              acte: null,
              total: null
            }]);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "t2",
              date: "REMISE -" + response.data.company.commercial_rate.toString() + "%",
              company_part: com_amount.toLocaleString("Fr"),
              patient: null,
              patient_part: null,
              beneficiary: null,
              acte: null,
              total: null
            }]);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "t3",
              date: "NET A PAYER (GNF) ",
              company_part: tbp_amount.toLocaleString("Fr"),
              patient: null,
              beneficiary: null,
              acte: null,
              patient_part: null,
              total: null
            }]);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "t4",
              date: "TAXE/RETENUE (GNF) - " + response.data.company.tax_rate.toString() + "%",
              company_part: tax_amount.toLocaleString("Fr"),
              patient: null,
              beneficiary: null,
              acte: null,
              patient_part: null,
              total: null
            }]);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "t5",
              date: "NET A PAYER (GNF)",
              company_part: final_amount.toLocaleString("Fr"),
              patient: null,
              beneficiary: null,
              acte: null,
              patient_part: null,
              total: null
            }]);
          });
        }
      }
    })["catch"](function (error) {
      message.error({
        content: error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };

  var onSearchFinish = function onSearchFinish(values) {
    setDataChanged(true);
    setListOfBills([]);
    setBillsArrayData([]);
    setFrom(moment(new Date(values.range[0]._d)).format());
    setTo(moment(new Date(values.range[1]._d)).format());
    setSelectedCompanyId(values.company_id);
    fetchBillsData(values.range[0]._d, values.range[1]._d, values.company_id);
  };

  useEffect(function () {
    fetchBillsData(from, to, selectedCompanyId);
  }, [dataChanged, selectedCompanyId]);
  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      setIsDataLoading(false);

      if (response.data.status == 200 && response.data.companyList.length > 0) {
        setCompanyList([]);
        response.data.companyList.forEach(function (ic) {
          setCompanyList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: ic.label,
              value: ic.id
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Form, {
            form: form,
            size: "large",
            onFinish: onSearchFinish,
            layout: "horizontal",
            children: /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 4,
                sm: 12,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "company_id",
                  rules: [{
                    required: true,
                    message: "Choisir une entreprise"
                  }],
                  children: /*#__PURE__*/_jsx(Select, {
                    placeholder: "Choisir une entreprise",
                    options: companyList
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 5,
                sm: 12,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "range",
                  rules: [{
                    required: true,
                    message: "Champs obligatoire"
                  }],
                  children: /*#__PURE__*/_jsx(RangePicker, {
                    ranges: rangePresets,
                    showTime: {
                      format: 'HH:mm'
                    },
                    format: "DD-MM-YYYY HH:mm"
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 3,
                sm: 12,
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      disabled: companyList.length == 0,
                      type: "primary",
                      htmlType: "submit",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "RECHERCHE"
                      })
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      type: "primary",
                      onClick: handleExport,
                      style: {
                        background: "#34C482"
                      },
                      icon: /*#__PURE__*/_jsx(Download, {
                        size: 28
                      }),
                      children: /*#__PURE__*/_jsx("b", {
                        children: "EXPORTER"
                      })
                    })
                  })]
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Divider, {}), listOfBills && listOfBills.length > 0 && /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsxs("div", {
              className: "cool-radius white-bg",
              style: {
                padding: '40px'
              },
              children: [/*#__PURE__*/_jsxs(AntRow, {
                children: [/*#__PURE__*/_jsx(AntCol, {
                  span: 6,
                  children: /*#__PURE__*/_jsx("img", {
                    src: "drawables/logo_sos.jpeg",
                    style: {
                      width: '130px'
                    }
                  })
                }), /*#__PURE__*/_jsx(AntCol, {
                  span: 6
                })]
              }), /*#__PURE__*/_jsx(AntRow, {
                children: /*#__PURE__*/_jsxs(AntCol, {
                  span: 6,
                  offset: 18,
                  children: [/*#__PURE__*/_jsxs("div", {
                    style: {
                      fontWeight: "bold",
                      fontStyle: 'italic'
                    },
                    children: ["Du ", new Date(from).toLocaleDateString("Fr"), " Au ", new Date(to).toLocaleDateString("Fr")]
                  }), /*#__PURE__*/_jsx("h4", {
                    children: company && company.label
                  })]
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(AntRow, {
                children: /*#__PURE__*/_jsx(AntCol, {
                  span: 24,
                  children: /*#__PURE__*/_jsx(Table, {
                    size: "small",
                    columns: cols,
                    bordered: true,
                    sticky: true,
                    loading: isDataLoading,
                    dataSource: billsArrayData,
                    scroll: {
                      y: 820
                    },
                    pagination: false
                  })
                })
              })]
            })
          })]
        })
      })
    })
  });
};

export default CompanyBills;